import { SVGProps } from 'react';

export const SvgDelivery = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M8.33366 14.166H11.667M11.667 14.166V4.16602H1.66699V14.166H4.16699M11.667 14.166H12.5003M16.667 14.166H18.3337V11.3827C18.334 10.9448 18.2481 10.5112 18.0808 10.1065C17.9135 9.70187 17.6681 9.33414 17.3587 9.02435L15.8337 7.49935H11.667M8.33366 14.5827C8.33366 15.7333 7.40092 16.666 6.25033 16.666C5.09973 16.666 4.16699 15.7333 4.16699 14.5827C4.16699 13.4321 5.09973 12.4993 6.25033 12.4993C7.40092 12.4993 8.33366 13.4321 8.33366 14.5827ZM16.667 14.5827C16.667 15.7333 15.7343 16.666 14.5837 16.666C13.4331 16.666 12.5003 15.7333 12.5003 14.5827C12.5003 13.4321 13.4331 12.4993 14.5837 12.4993C15.7343 12.4993 16.667 13.4321 16.667 14.5827Z"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
